export default __webpack_public_path__ + "static/media/Timesheet_filled.6ab303f7.svg";